let api = window.location.protocol+'//'+window.location.hostname+':5001/';
if(window.location.hostname!='localhost'){
    api = 'https://apievde.econex.live/';
}

export default{
    api,
    config : {headers: {'access-token': sessionStorage.token}}
}